import * as yup from 'yup';

export const validationScheme = (isActive, promoCodesAmount) =>
  yup.object({
    partner_id: yup.object().required('Обязательное поле'),
    cms_package_id: yup.object().required('Обязательное поле'),
    discount:
      yup.number()
        .transform(value => (isNaN(value) ? undefined : value))
        .test('numbers', 'Допустимы только цифры', value => value ? /^[0-9]+$/.test(value) : true)
        .nullable(),
    date_start: isActive ? yup.date().required() :
      yup.date()
        .min(new Date(), () => ({
          dateStartNotValid: 'Дата начала не может быть раньше текущей'
        }))
        .required(),
    date_end:
      yup.date()
        .transform((date) => date.setHours(23,59,59))
        .min(yup.ref('date_start'), () => ({
          dateEndNotValid: 'Дата окончания не может быть ранее Даты начала'
        }))
        .transform((date) => new Date(date))
        .required(),
    site_url: yup.string().nullable(),
    promo_code_amount: yup.number().when('generate_promo_code', {
      is: (val) => (typeof val === 'boolean' ? !!val : val === 'auto'),
      then: yup.number()
        .min(promoCodesAmount, 'min 1')
        .transform(value => (isNaN(value) ? undefined : value))
        .test('numbers', 'Допустимы только цифры', value => /^[0-9]+$/.test(value))
        .required(),
    }),
    customer_files: yup.array().when('show_all', {
      is: (val) => (typeof val === 'boolean' ? !val : val === 'files'),
      then: yup.array().required().min(1, 'one files min'),
      otherwise: yup.array()
    }),
    promo_code_files: yup.array().when('generate_promo_code', {
      is: (val) => (typeof val === 'boolean' ? !val : val === 'files'),
      then: yup.array().required().min(1, 'one files min'),
      otherwise: yup.array()
    })
  });

export const createPromotionFields = (values, customTouched, isEdit) => {
  const dateToString = (date) => `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}-${date.getUTCDate()}`;

  const fields = {
    ...values,
    cities_id: values.cities_id.filter(city => city.value !== 'all').map(city => city.value),
    all_cities: !!values.cities_id.find(city => city.value === 'all') || values.cities_id.length === 0,
    cms_package_id: values.cms_package_id.id,
    partner_id: values.partner_id.id,
    promo_code_amount: values.generate_promo_code === 'files' ? 0 : +values.promo_code_amount,
    discount: +values.discount || null,
    date_end: dateToString(
      (function() {
        const date = values?.date_end ? new Date(values?.date_end) : new Date();
        date.setHours(23,59,59);
        return date
      })()
    ),
    date_start: new Date(values.date_start),
    customer_files: values.show_all === 'files' || !values.show_all ? values.customer_files.map(item => item.id) || [] : undefined,
    promo_code_files: values.generate_promo_code === 'files' || !values.generate_promo_code ? values.promo_code_files.map(item => item.id) || [] : undefined,
    show_all: typeof values.show_all === 'boolean' ? values.show_all : values.show_all === 'all',
    generate_promo_code: typeof values.generate_promo_code === 'boolean' ? values.generate_promo_code : values.generate_promo_code === 'auto',
    is_enabled_promocodes: values.generate_promo_code !== 'none'
  };

  if (!isEdit) return fields;

  const updatesFields = Object.keys(fields).reduce((acc, item) => {
    customTouched[item] ? (acc[item] = fields[item]) : {};
    return acc;
  }, {});

  if (customTouched.show_all) updatesFields.show_all = updatesFields.show_all === true;
  if (customTouched.generate_promo_code) updatesFields.generate_promo_code = updatesFields.generate_promo_code === true;
  if (customTouched.generate_promo_code && updatesFields.generate_promo_code === false) {
    updatesFields.promo_code_amount = 0;
    updatesFields.promo_code_files = updatesFields.promo_code_files || fields.promo_code_files;
  }
  if (updatesFields.promo_code_amount && fields.generate_promo_code) updatesFields.generate_promo_code = true;

  return updatesFields;
}

